export default __webpack_public_path__ + "static/media/universe1.3900b053.png";